import { base64ToArrayBuffer } from "./audio.js";
export function attachConnectionToOutput(connection, output) {
    const listener = event => {
        output.playAudio(base64ToArrayBuffer(event.audio_base_64));
    };
    connection.addListener(listener);
    return () => {
        connection.removeListener(listener);
    };
}
//# sourceMappingURL=attachConnectionToOutput.js.map